import { createSlice } from '@reduxjs/toolkit'

import { addToGroup } from '../common_actions'
import { initialState } from './initial_state'

const slice = createSlice({
  name: 'userGroup/assignAdmins',
  initialState: { ...initialState },
  reducers: {
    openPopup(state) {
      state.isPopupOpen = true
    },
    closePopup(state) {
      state.individualMemberForPopup = initialState.individualMemberForPopup
      state.isPopupOpen = initialState.isPopupOpen
    },
    setIndividualMemberForPopup(state, { payload }) {
      state.individualMemberForPopup = payload
    },
    setPopupView(state, { payload }) {
      state.popupView = payload
    },
    setPageType(state, { payload }) {
      state.pageType = payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(addToGroup.pending, (state) => {
      state.pending = true
    })
    builder.addCase(addToGroup.fulfilled, () => initialState)
    builder.addCase(addToGroup.rejected, (state) => {
      state.pending = initialState.pending
    })
  }
})

export const {
  closePopup,
  openPopup,
  setIndividualMemberForPopup,
  setPageType,
  setPopupView,
} = slice.actions
export const { reducer } = slice
